// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1RupN","content":"GlobalSearch_content__3tavZ"};